<template>
  <div>
    <div
      v-if="isDesktop"
      class="announce-bar responsive-visible desktop"
    >
      <span class="announce-bar__content">
        플랜 종료를 앞두고 있습니다. 이용에 불편없도록 미리 결제하세요!
      </span>
      <a
        class="button_buy-now"
        href="https://bit.ly/3ICI33I"
        target="_blank"
      >
        지금 바로 등록
      </a>
    </div>
    <div
      v-else
      class="announce-bar responsive-visible mobile"
    >
      <span class="announce-bar__content">
        플랜 종료를 앞두고 있습니다.
      </span>
      <a
        class="button_buy-now"
        href="https://bit.ly/3ICI33I"
        target="_blank"
      >
        지금 바로 등록
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrePaymentBar',
  props: {
    isDesktop: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
</style>
